const MAX = 10000;

export const zIndex = {
  MediaPreview: MAX,
  TimelineModal: MAX - 1,
  ChatDetailsModal: MAX - 2,
  HistoryConversationModal: MAX - 3
};
